// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.react-pdf__Page__textContent {
    border: 1px solid darkgrey;
    box-shadow: 5px 5px 5px 1px #ccc;
    border-radius: 5px;
    margin: 0 auto;
}

.react-pdf__Page__canvas {
    margin: 0 auto;
}
.react-pdf__Page__canvas:active {
    background: transparent;
    border: none;
    outline: none;
}
.textLayer {
    z-index: auto !important;
}

.react-pdf__Page__annotations.annotationLayer {
    padding: 20px;
}

.react-pdf__Page {
    margin-top: 10px;
}

.digitizationEditorToolbar {
    border-bottom: none;
    display: flex;
    gap: 0.5em;
    padding-left: .5%;
    padding-top: .5%;
    background: #363537;
}

.DigitizationEditorCanvas {
    border: 1px solid #e0d8d8b0;
    height: calc(100vh - 192px);
    background: white;
}

.digitizationEditorContentSection {
    border: 1px solid #e0d8d8b0;
    width: 60%;
    border-left: none;
    overflow-y: auto;
}

.digitizationEditorMarkdownSection {
    border: 1px solid #e0d8d8b0;
    width: 60%;
    border-left: none;
    overflow-y: auto;
}

.labelingEditorHeader {
    height: 8%;
}



.yai4eduEditorLayout {
    display: flex;
    flex-direction: column;
}

.body-component  {
    display: flex;
    height: 100%;
}

.resize-handle {
    height: 100%;
    cursor: col-resize;
    position: absolute;
    top: 0;
    width: 10px;
}

.digitization-note{
    box-sizing: border-box;
    width: 100%;
    background-color: white;
    border: thin solid #dcdbdb;
    border-radius: 2px;
    display: inline-block;
    font: inherit;
    height: auto;
}

.thumbnail-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    position: relative;
    background: #363537;
}

.thumbnail-container {
    display: flex;
    overflow-x: hidden;
    max-width: 90%;
    padding: 10px;
    scroll-behavior: smooth;
}

.thumbnail {
    cursor: pointer;
    padding: 5px;
}

.thumbnail img {
    width: 50px;
    height: auto;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.thumbnail.active img {
    border: 2px solid blue;
}

.thumbnail .highlighted {
    color: blue;
    font-weight: bold;
}

.thumbnail .page-number {
    font-size: 10px;
    text-align: center;
    margin-top: 5px;
    color: white;

}

.nav-arrow {
    background-color: #525151;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    position: absolute;
    z-index: 1;
}

.left-arrow {
    left: 0;
}

.right-arrow {
    right: 0;
}


`, "",{"version":3,"sources":["webpack://./src/mainComponents/yai4eduEditor/editorStyleSheet.css"],"names":[],"mappings":";AACA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;;;AAIA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ","sourcesContent":["\n.react-pdf__Page__textContent {\n    border: 1px solid darkgrey;\n    box-shadow: 5px 5px 5px 1px #ccc;\n    border-radius: 5px;\n    margin: 0 auto;\n}\n\n.react-pdf__Page__canvas {\n    margin: 0 auto;\n}\n.react-pdf__Page__canvas:active {\n    background: transparent;\n    border: none;\n    outline: none;\n}\n.textLayer {\n    z-index: auto !important;\n}\n\n.react-pdf__Page__annotations.annotationLayer {\n    padding: 20px;\n}\n\n.react-pdf__Page {\n    margin-top: 10px;\n}\n\n.digitizationEditorToolbar {\n    border-bottom: none;\n    display: flex;\n    gap: 0.5em;\n    padding-left: .5%;\n    padding-top: .5%;\n    background: #363537;\n}\n\n.DigitizationEditorCanvas {\n    border: 1px solid #e0d8d8b0;\n    height: calc(100vh - 192px);\n    background: white;\n}\n\n.digitizationEditorContentSection {\n    border: 1px solid #e0d8d8b0;\n    width: 60%;\n    border-left: none;\n    overflow-y: auto;\n}\n\n.digitizationEditorMarkdownSection {\n    border: 1px solid #e0d8d8b0;\n    width: 60%;\n    border-left: none;\n    overflow-y: auto;\n}\n\n.labelingEditorHeader {\n    height: 8%;\n}\n\n\n\n.yai4eduEditorLayout {\n    display: flex;\n    flex-direction: column;\n}\n\n.body-component  {\n    display: flex;\n    height: 100%;\n}\n\n.resize-handle {\n    height: 100%;\n    cursor: col-resize;\n    position: absolute;\n    top: 0;\n    width: 10px;\n}\n\n.digitization-note{\n    box-sizing: border-box;\n    width: 100%;\n    background-color: white;\n    border: thin solid #dcdbdb;\n    border-radius: 2px;\n    display: inline-block;\n    font: inherit;\n    height: auto;\n}\n\n.thumbnail-navigation {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 10px;\n    position: relative;\n    background: #363537;\n}\n\n.thumbnail-container {\n    display: flex;\n    overflow-x: hidden;\n    max-width: 90%;\n    padding: 10px;\n    scroll-behavior: smooth;\n}\n\n.thumbnail {\n    cursor: pointer;\n    padding: 5px;\n}\n\n.thumbnail img {\n    width: 50px;\n    height: auto;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.thumbnail.active img {\n    border: 2px solid blue;\n}\n\n.thumbnail .highlighted {\n    color: blue;\n    font-weight: bold;\n}\n\n.thumbnail .page-number {\n    font-size: 10px;\n    text-align: center;\n    margin-top: 5px;\n    color: white;\n\n}\n\n.nav-arrow {\n    background-color: #525151;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    cursor: pointer;\n    position: absolute;\n    z-index: 1;\n}\n\n.left-arrow {\n    left: 0;\n}\n\n.right-arrow {\n    right: 0;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
